import axios from "axios";
import {
  activeUsersRequested,
  activeUsersRequestSucceeded,
  activeUsersRequestFailed,
} from "../slices/GetActiveUsersSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/User/GetActiveByCountry?country=${encodeURIComponent(selectedCountry)}`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const getActiveUsers = () => async (dispatch) => {
  try {
    dispatch(activeUsersRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(activeUsersRequestSucceeded(response.data));
  } catch (error) {
    dispatch(activeUsersRequestFailed(error.message));
  }
};
